import React, { useEffect } from "react";
import Header from "@components/Header/Header";
import { SKY_BLUE } from "@styles/colors";
import { useNavigate } from "react-router";
import {
    Container,
    ContentContainer,
    PageWrapper,
    Title,
    ServiceButtonsWrapper,
    ServiceContainer,
    EmptyStateText,
} from "./PaymentPoint.styles";
import { useTranslation } from "react-i18next";
import { setHeaderColor } from "@lib/telegram";
import ServiceButton from "@components/ServiceButton/ServiceButton";
import { usePpobServices } from "@hooks/usePpobServices";
import LoadingModal from "@components/LoadingModal/LoadingModal";

// Map service codes to translation keys
const SERVICE_CODE_TO_TRANSLATION_KEY: Record<string, string> = {
    'DIGIFLAZZ:MOBILE_PREPAID': 'paymentPoint.services.phoneCredit',
    'DIGIFLAZZ:MOBILE_DATA_PACKAGE': 'paymentPoint.services.mobileData',
    'DIGIFLAZZ:MOBILE_POSTPAID': 'paymentPoint.services.phoneBilling',
    'ESIM_DATA': 'paymentPoint.services.esimData',
    'ESIM_CREDIT': 'paymentPoint.services.esimCredit',
    'BPJS': 'paymentPoint.services.bpjs',
    'DIGIFLAZZ:ELECTRICITY_PREPAID': 'paymentPoint.services.pln',
    'INTERNET': 'paymentPoint.services.cableTV',
    'PDAM': 'paymentPoint.services.pdam',
    'DIGIFLAZZ:EMONEY': 'paymentPoint.services.eToll',
    'BUY_ESIM': 'paymentPoint.services.buyEsim',
};

const PaymentPoint = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { services: apiServices, getPpobServices, isLoading } = usePpobServices();

    useEffect(() => {
        setHeaderColor(SKY_BLUE)
        getPpobServices()
    }, [])

    const services = apiServices
        .filter((service) => service.tma_navigate_to)
        .map((service) => ({
            id: service.code,
            imageUrl: service.image_url,
            title: SERVICE_CODE_TO_TRANSLATION_KEY[service.code]
                ? t(SERVICE_CODE_TO_TRANSLATION_KEY[service.code])
                : service.name,
            onClick: () => navigate(service.tma_navigate_to!, {
                state: { category: service.category }
            }),
        }));

    return (
        <PageWrapper>
            <LoadingModal visible={isLoading} />
            <Container>
                <Header title={t('paymentPoint.header')} showBackButton onBackClick={() => navigate('/home')} $transparent />
                <Title>{t('paymentPoint.title')}</Title>
            </Container>
            <ContentContainer>
                <ServiceContainer>
                    {services.length === 0 ? (
                        <EmptyStateText>{t('paymentPoint.emptyState')}</EmptyStateText>
                    ) : (
                        <ServiceButtonsWrapper>
                            {services.map((service) => (
                                <ServiceButton
                                    key={service.id}
                                    imageUrl={service.imageUrl}
                                    title={service.title}
                                    onClick={service.onClick}
                                />
                            ))}
                        </ServiceButtonsWrapper>
                    )}
                </ServiceContainer>
            </ContentContainer>
        </PageWrapper>
    );
};

export default PaymentPoint;
